module.exports = __webpack_public_path__ + "img/Flag_of_Wallis_and_Futuna.25439633.svg";